/* Bottles Arabic storefront: localizes money printed by Horizon components (cart, drawer,
   quick add) to Arabic-Indic digits with ج.م, and translates a few theme-content strings.
   Loaded only when the Arabic locale is active. */
(() => {
  if (document.documentElement.lang !== 'ar') return;

  const DIGITS = '٠١٢٣٤٥٦٧٨٩';
  const MONEY = /\b(?:LE|EGP)\s?([0-9][0-9,]*(?:\.[0-9]+)?)(?:\s?EGP)?/g;
  const HAS_MONEY = /\b(?:LE|EGP)\s?[0-9]/;
  const PHRASES = new Map([
    ['You may also like', 'ممكن يعجبك كمان'],
    ['You may also like ', 'ممكن يعجبك كمان'],
  ]);
  const SKIP = new Set(['SCRIPT', 'STYLE', 'TEXTAREA', 'INPUT', 'NOSCRIPT', 'CODE', 'PRE', 'svg']);

  const toArabic = (amount) =>
    amount
      .replace(/\.00$/, '')
      .replace(/[0-9]/g, (digit) => DIGITS[digit])
      .replace(/,/g, '٬')
      .replace(/\./g, '٫');

  const fixText = (node) => {
    const value = node.nodeValue;
    if (!value || !value.trim()) return;
    let next = value;
    if (HAS_MONEY.test(next)) next = next.replace(MONEY, (_, amount) => `${toArabic(amount)} ج.م`);
    const trimmed = next.trim();
    if (PHRASES.has(trimmed)) next = next.replace(trimmed, PHRASES.get(trimmed));
    if (next !== value) node.nodeValue = next;
  };

  const accept = (node) => (SKIP.has(node.parentNode?.nodeName) ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT);

  const walk = (root) => {
    if (!root) return;
    if (root.nodeType === Node.TEXT_NODE) {
      if (accept(root) === NodeFilter.FILTER_ACCEPT) fixText(root);
      return;
    }
    if (root.nodeType !== Node.ELEMENT_NODE || SKIP.has(root.nodeName)) return;
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, { acceptNode: accept });
    let current;
    while ((current = walker.nextNode())) fixText(current);
  };

  const queue = new Set();
  let scheduled = false;
  const flush = () => {
    scheduled = false;
    queue.forEach((node) => {
      if (node.isConnected) walk(node);
    });
    queue.clear();
  };

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.type === 'characterData') queue.add(mutation.target);
      mutation.addedNodes.forEach((node) => queue.add(node));
    }
    if (!scheduled && queue.size) {
      scheduled = true;
      window.requestAnimationFrame(flush);
    }
  });

  const start = () => {
    walk(document.body);
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
